import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleUp, faCircleDown } from '@fortawesome/free-regular-svg-icons'
import { faXmark, faCircleNotch, faRotate } from '@fortawesome/free-solid-svg-icons'
import { useState, useRef, useEffect } from "react";
import { toast } from 'react-hot-toast';
import Modal from 'react-modal';
import { formatCurrency} from '../utils/currencyUtils';
import Select from "react-select";

function RowList3({data}) {  
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [amount, setAmount] = useState(0);
    const [type, setType] = useState("profit");
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const menuRef = useRef();
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const AddProfit = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ setProfit: true, id: data.id, type:type, amount:amount })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }
    const Delete = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteTrade: true, id: id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const typeoptions = [
        { value: "profit", label: "Add profits" },
        { value: "loss", label: "Add loss" }
    ];

    useEffect(() => {
        if(type && amount){
            setDisable(false);
        }else{
            setDisable(true);
        }
    }, [type, amount]);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    return (
        <>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Add profits</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <p className="mb-3 text-light fw-semibold" style={{fontSize: '15px'}}>Add profits or loss to this trade. The profits (or loss) will be added to user's USD account once the trade is closed</p>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
            <Select 
                options={typeoptions} 
                value={typeoptions.find((opt) => opt.value === type)}
                onChange={(e) => setType(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="1000" 
                    className="inputNone"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                USD
                </div>
            </div>
            <div className='d-flex align-items-center mt-3 justify-content-between'>
                <p className='mb-0'>Entry price</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.entry)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Direction</p>
                <p className='mb-0 fw-bold'>{data.action.charAt(0).toUpperCase() + data.action.slice(1)}</p>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
                <p className='mb-0'>Current pnl:</p>
                <p className='mb-0 fw-bold'>${formatCurrency(data.result)}</p>
            </div>
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => {if (!disable) {AddProfit();}
            }}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:`Add ${formatCurrency(amount)} ${type}`}</div>
        </Modal>
        <tr className="fw-semibold">
            <td>#{data.trade_id}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td className='text-nowrap'>{data.trade_time}</td>
            <td className='text-nowrap'><img src={data.logo} alt="Method" style={{width: '20px'}} /> <span className='ms-2 fw-bold text-nowrap'>{data.pair}</span></td>


            <td className="text-nowrap fw-bold">
              {parseFloat(data.amount).toFixed(6)} {data.symbol}{" "}
              <FontAwesomeIcon
                className={`ms-1 ${
                  data.action === "Buy"
                    ? "text-success"
                    : data.action === "Sell"
                    ? "text-danger"
                    : "text-prime"
                }`}
                icon={
                  data.action === "Buy"
                    ? faCircleUp
                    : data.action === "Sell"
                    ? faCircleDown
                    : faRotate
                }
                style={{ fontSize: "15px" }}
              />
            </td>
            <td
              className={`text-nowrap fw-bold 
                ${data.result >= 0 
                  ? "text-success" 
                  : data.result < 0 
                  ? "text-danger" 
                  : "text-prime"}`}
            >
              ${data.result}
            </td>
            <td className={`${data.details === 'Running' ? 'text-success' : data.details === 'Loss' ? 'text-danger' : 'text-danger'}`}>{data.details === 'Running' ? 'Open' : 'Closed'}</td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                > 
                  {data.action != "Swap" && (
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => setIsOpen(true)}>
                    Add Profits
                    </div>
                  )}
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete(data.id)}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        </>
    )
  }
  
  export default RowList3